//--- Import Export Config here
export const WMS = "https://cargis.vn:8440/geoserver/daknong2022/wms/";
export const APIUrl = "https://api-giadatdarknong.cargis.vn";
export const AdminUrl = "https://admin-giadatdarknong.cargis.vn";
